(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["faq-accordion"]) return;
  try {
    


(function($){

$('.accordion-item-heading').on('click', function(){
  var $parent = $(this).parent();
  if($parent.hasClass('open')){
    $parent.removeClass('open');
  } else {
    $('.accordion-item').removeClass('open');
    $parent.addClass('open');
  }
});

})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function($){

  var targetElement = document.querySelector('.mobile-menu');

  $('.navigation-trigger').on('click', function(){
	if($(this).hasClass('open')){
		$(this).removeClass('open');
		$('.mobile-menu').removeClass('open');
		bodyScrollLock.enableBodyScroll(targetElement);
	} else {
		$(this).addClass('open');
		$('.mobile-menu').addClass('open');
		bodyScrollLock.disableBodyScroll(targetElement);
	}
  });

  $('.sub-menu-trigger').on('click', function(){
	if($(this).hasClass('open')){
		$(this).removeClass('open');
        $(this).next().removeClass('open');
	} else {
		$(this).addClass('open');
        $(this).next().addClass('open');
    }
  });

})(jQuery);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animated-HOME"] && !window.DesignMode) return;
  try {
    
(function($){
  $('.hero-slider .slides').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    dots: false,
    responsive: [
    {
      breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 6000,
          infinite: true,
          dots: true,
          centerMode: true
        }
    }
    ]
  });
})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"]) return;
  try {
    
	(function($){
		var $table = $('.product-single__description table');
		var $head = $('.product-single__description table tbody tr:nth-child(1) td');
		var $body = $('.product-single__description table tbody tr:nth-child(2) td');

		$head.each(function(){
			var html = $(this).html();
			
			$('.tabs-head').append('<div class="tabs-head-item">' + html + '</div>');
		});

		$body.each(function(){
			var html = $(this).html();
			
			$('.tabs-body').append('<div class="tabs-body-item">' + html + '</div>');
		});

		$table.css({'display':'none'});

		$('.tabs-head-item:nth-child(1)').addClass('active');
		$('.tabs-body-item:nth-child(1)').addClass('active');

		$('.tabs-head-item').on('click', function(){
			var index = $(this).index() + 1;
			$('.tabs-head-item').removeClass('active');
			$(this).addClass('active');
			$('.tabs-body-item').removeClass('active');
			$('.tabs-body-item:nth-child(' + index + ')').addClass('active');
			console.log(index);
		});
	})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns-performance-1"] && !window.DesignMode) return;
  try {
    

(function($){
$('.learn-more-trigger').on('click', function(){
  var $this = $(this);
  if($this.hasClass('open')) {
    $this.removeClass('open');
    $this.next().removeClass('open');
  } else {
    $this.addClass('open');
    $this.next().addClass('open');
  }
});

})(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tippers-and-text"] && !window.DesignMode) return;
  try {
    
(function($){
	$('.tipper').on('mouseenter', function(e){
		$(this).css({'z-index': '10'});
	});
	$('.tipper').on('mouseleave', function(e){
		$(this).css({'z-index': 'auto'});
	});
})(jQuery)


  } catch(e) { console.error(e); }
})();

})();
